import c from '@/styles/Checkbox';
import { ClassNameProp, ComponentProps, ComponentWithRef } from '@/types/component';
import { cn } from 'lib/utils/cn';
import { getPropStylesFactory } from 'lib/utils/getPropStylesFactory';
import React from 'react';

export interface CheckboxInputProps extends Omit<ComponentProps<'input'>, 'size'> {
  colors?: ClassNameProp<'default' | 'alternative'>;
  size?: ClassNameProp<'default' | 'alternative'>;
  variant?: ClassNameProp<'default' | 'alternative'>;
}

export const CheckboxInputComponent: ComponentWithRef<HTMLInputElement, CheckboxInputProps> = React.forwardRef(
  ({ children, className, colors, size, variant, ...props }, ref) => {
    const getPropStyles = getPropStylesFactory(c);

    const colorsClassName = getPropStyles('input_colors', colors ?? variant, 'default');
    const sizeClassName = getPropStyles('input_size', size ?? variant, 'default');
    const variantClassName = getPropStyles('input_variant', variant, 'default');
    const componentClassName = cn('cursor-pointer', colorsClassName, sizeClassName, variantClassName, className);

    return <input className={componentClassName} {...{ ref }} {...props} />;
  }
);
